import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import moment from 'moment';
import { actionCreators } from '../../store/modules/User';
import SelectField from '../../controls/SelectField';
import {
  YesNo, ConvertToOptions, Gender, GetDays, GetMonths, GetYears,
} from '../../utils/enum';

class UserRegister extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      registration: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { registration } = this.state;
    const { resetRegistration } = this.props;

    if (nextProps.registration && !registration) {
      this.setState({ registration: true }, () => resetRegistration());
    }
  }

  handleFacebookCallback(resposne) {
    if (resposne.userID && resposne.accessToken) {
      if (resposne.email) {
        this.form.current.setFieldValue('email', resposne.email);
      }
      this.form.current.setFieldValue('facebookUserId', resposne.userID);
      this.form.current.setFieldValue('facebookAccessToken', resposne.accessToken);
    }
  }

  handleGoogleCallback(resposne) {
    if (resposne.googleId && resposne.accessToken) {
      if (resposne.profileObj && resposne.profileObj.email) {
        this.form.current.setFieldValue('email', resposne.profileObj.email);
      }
      this.form.current.setFieldValue('googleUserId', resposne.googleId);
      this.form.current.setFieldValue('googleAccessToken', resposne.accessToken);
    }
  }

  handleSave(values) {
    const { requestRegistration, requestRegistrationConfirmation } = this.props;
    const { registration } = this.state;

    if (registration) {
      requestRegistrationConfirmation(values);
    } else {
      requestRegistration(values);
    }
  }

  testPassword(value) {
    return this.parent.password === value;
  }

  testDate() {
    const date = moment([this.parent.birthdayOnYear, this.parent.birthdayOnMonth - 1, this.parent.birthdayOnDay]);
    return date.isValid();
  }

  testPhone() {
    return new RegExp('^\\+371[0-9]{8}$').test(this.parent.phone);
  }

  render() {
    const { registration } = this.state;

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email()
            .min(5)
            .max(254)
            .required(),
          phone: Yup.string()
            .min(12)
            .max(12)
            .required()
            .test('valid-phone', 'Nepareizs tālrunis', this.testPhone),
          birthdayOnDay: Yup.number()
            .integer()
            .required()
            .test('valid-date', 'Nepareizs datums', this.testDate),
          birthdayOnMonth: Yup.number()
            .integer()
            .required()
            .test('valid-date', 'Nepareizs datums', this.testDate),
          birthdayOnYear: Yup.number()
            .integer()
            .required()
            .test('valid-date', 'Nepareizs datums', this.testDate),
          isMale: Yup.bool().nullable(),
          isSubscribed: Yup.bool().required(),
          agreement: Yup.bool()
            .oneOf([true])
            .required(),
          imageId: Yup.string().nullable(),
          facebookUserId: Yup.string().nullable(),
          facebookAccessToken: Yup.string().nullable(),
          googleUserId: Yup.string().nullable(),
          googleAccessToken: Yup.string().nullable(),
          code: registration
            ? Yup.string().matches(/^[0-9]{6}$/).required() : Yup.string().nullable(),
        })}
        initialValues={{
          email: '',
          password: '',
          passwordConfirm: '',
          phone: '+371',
          cardNo: '',
          birthdayOnDay: '',
          birthdayOnMonth: '',
          birthdayOnYear: '',
          isSubscribed: '',
          isMale: '',
          agreement: '',
          imageId: '',
        }}
        render={({ errors, values, setFieldValue }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-sm-12">
                  <span className="page-title no-image">Reģistrācija</span>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading" />
                    <div className="panel-body" id="scroller">
                      <div className="col-md-9">
                        {!registration && (
                          <React.Fragment>
                            <div className="row">
                              <div className="col-xs-6 facebook-login">
                                <FacebookLogin appId="498455930892183"
                                  textButton={
                                    values.facebookUserId ? 'Savienots ar Facebook kontu' : 'Savienot ar Facebook kontu'
                                  }
                                  isDisabled={values.facebookUserId}
                                  fields="first_name,last_name,email"
                                  callback={response => this.handleFacebookCallback(response)} />
                              </div>
                              <div className="col-xs-6 google-login">
                                <GoogleLogin clientId="919517785115-a3914c9hvghto8jlvcsmvl8uuvm78pjs.apps.googleusercontent.com"
                                  buttonText={values.googleUserId ? 'Savienots ar Google kontu' : 'Savienot ar Google kontu'}
                                  disabled={values.googleUserId}
                                  scope="profile email"
                                  onSuccess={response => this.handleGoogleCallback(response)} />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="email" className="control-label font-bold">
                                    Epasts
                                    <Field id="email"
                                      name="email"
                                      type="email"
                                      autoFocus
                                      autoComplete="off"
                                      className={errors.email ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="phone" className="control-label font-bold">
                                    Tālrunis
                                    <Field id="phone"
                                      name="phone"
                                      onChange={(e) => {
                                        if (e.target.value.startsWith('+371')) {
                                          setFieldValue('phone', e.target.value);
                                        } else {
                                          setFieldValue('phone', '+371');
                                        }
                                      }}
                                      autoComplete="off"
                                      className={errors.phone ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="birthdayOn" className="control-label font-bold">
                                    Dzimšanas diena (diena/mēnesis/gads)
                                    <div className="form-inline birthday-fields">
                                      <Field id="birthdayOnDay"
                                        name="birthdayOnDay"
                                        component={SelectField}
                                        isClearable={false}
                                        options={GetDays()}
                                        style={{ width: '30%' }}
                                        className={errors.birthdayOnDay ? 'form-control error' : 'form-control'} />
                                      <Field id="birthdayOnMonth"
                                        name="birthdayOnMonth"
                                        component={SelectField}
                                        isClearable={false}
                                        options={GetMonths()}
                                        className={errors.birthdayOnMonth ? 'form-control error' : 'form-control'} />
                                      <Field id="birthdayOnYear"
                                        name="birthdayOnYear"
                                        component={SelectField}
                                        isClearable={false}
                                        options={GetYears()}
                                        className={errors.birthdayOnYear ? 'form-control error' : 'form-control'} />
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="isMale" className="control-label font-bold">
                                    Dzimums
                                    <Field id="isMale"
                                      name="isMale"
                                      component={SelectField}
                                      options={ConvertToOptions(Gender)}
                                      className={errors.isMale ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="cardNo" className="control-label font-bold">
                                    Kartes Nr
                                    <Field id="cardNo"
                                      name="cardNo"
                                      autoComplete="off"
                                      className={errors.cardNo ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="isSubscribed" className="control-label font-bold">
                                    Pierakstījies jaunumiem
                                    <Field id="isSubscribed"
                                      name="isSubscribed"
                                      component={SelectField}
                                      options={ConvertToOptions(YesNo)}
                                      className={errors.isSubscribed ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div className="form-group form-group-lg label-static is-empty">
                                  <label htmlFor="agreement" className="control-label font-bold">
                                    Piekrist privātuma politikai
                                    <Field id="agreement"
                                      name="agreement"
                                      component={SelectField}
                                      options={ConvertToOptions(YesNo)}
                                      className={errors.agreement ? 'form-control error' : 'form-control'} />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        )}

                        {registration && (
                          <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                              <div className="form-group form-group-lg label-static is-empty">
                                <label htmlFor="code" className="control-label font-bold">
                                  SMS kods
                                  <Field id="code"
                                    name="code"
                                    autoFocus
                                    maxLength="6"
                                    className={errors.code ? 'form-control error' : 'form-control'} />
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <button type="submit" className="gaas-tile-btn">
                              {registration ? 'Apstiprināt' : 'Reģistrēties'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

UserRegister.propTypes = {
  requestRegistration: PropTypes.func.isRequired,
  requestRegistrationConfirmation: PropTypes.func.isRequired,
  resetRegistration: PropTypes.func.isRequired,
  registration: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    registration: state.user.registration,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(UserRegister);



// WEBPACK FOOTER //
// ./src/components/user/Register.jsx